import { emsClient } from '../api/clients';
import type { EmsComponents } from '../api/ems';

type CreateRequestedIncidentBody = EmsComponents['schemas']['CreateIncidentFromPortalRequest'];

export type RequestedIncidentPurpose = NonNullable<CreateRequestedIncidentBody['purpose']>;

type RequestedIncidentTextField = 'callerName' | 'label' | 'summary';

export type RequestedIncidentDetails = {
  [field in RequestedIncidentTextField]?: NonNullable<CreateRequestedIncidentBody[field]>;
} & {
  location?: NonNullable<CreateRequestedIncidentBody['location']>;
  purpose?: RequestedIncidentPurpose;
};

export type RequestedIncidentLocation = NonNullable<RequestedIncidentDetails['location']>;

function ensureSuccess(response: Response, action: string): void {
  if (!response.ok) {
    throw new Error(`${action} failed (HTTP ${response.status})`);
  }
}

export async function createIncident(
  requestedIncidentId: string,
  phoneNumbers: string[],
  details?: RequestedIncidentDetails,
): Promise<void> {
  const body = createRequestedIncidentBody(requestedIncidentId, phoneNumbers, details);
  const { response } = await emsClient().POST('/portal/v1/incident', { body });
  ensureSuccess(response, 'Create incident');
}

function createRequestedIncidentBody(
  requestedIncidentId: string,
  phoneNumbers: string[],
  details?: RequestedIncidentDetails,
): CreateRequestedIncidentBody {
  const distinctPhoneNumbers = [...new Set(phoneNumbers)];
  if (distinctPhoneNumbers.length > 1) {
    throw new Error('An Incident can be created for at most one distinct caller phone number.');
  }

  const phoneNumber = distinctPhoneNumbers[0];
  return {
    requestedIncidentId,
    ...(phoneNumber === undefined ? {} : { callerPhoneNumber: phoneNumber }),
    ...(details ?? {}),
    purpose: details?.purpose ?? 'Real',
  };
}
